import React, {
	memo,
	useCallback,
	useEffect,
	useMemo
} from 'react';
import {
	Redirect,
	Route,
	Switch,
	useRouteMatch
} from 'react-router-dom';

import { useAuthState } from '../../../contexts/AuthContext';
import { useUIAction } from '../../../contexts/UIContext';

import TagAdmin from './TagAdmin';
import UserAdmin from './UserAdmin';

const Administration = () => {
	let { path: currentPath } = useRouteMatch();

	const { user: { permissions } } = useAuthState();
	const { setSidebarMenu } = useUIAction();

	useEffect( () => {
		setSidebarMenu( 'administration' );
	}, [ setSidebarMenu ] );

	const paths = useMemo( () => {
		const pathsArr = [];

		if ( permissions.listUsers.isAvailable ) {
			pathsArr.push( {
				path: `${ currentPath }/users`,
				component: UserAdmin
			} );
		}

		if ( permissions.listTags.isAvailable ) {
			pathsArr.push( {
				path: `${ currentPath }/tags`,
				component: TagAdmin
			} );
		}

		return pathsArr;
	}, [
		currentPath,
		permissions
	] );

	const mapPaths = useCallback( () => paths.map( path => (
		<Route
			key={ path.path }
			{ ...path }
		/>
	) ), [ paths ] );

	return (
		<Switch>
			{ mapPaths() }
			<Redirect
				from="*"
				to={ paths[ 0 ].path }
			/>
		</Switch>
	);
};

export default memo( Administration );
